(function ($) {
  $(function () {
    $(window).on("load", function () {
      var winWidth = $(window).width();
      if (winWidth <= 767) {
        setTimeout(function () {
          $(".why-veriverse .logo-grid .row-wrap").css({ opacity: "1" });
        }, 500);

        $(".why-veriverse .logo-grid .row-wrap").slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          arrow: false,
          dots: true,
          speed: 500,
          autoplay: false,
          infinite: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 595,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: true,
              },
            },
          ],
        });
      }
    });
  });
})(jQuery);
